/** 运营数据看板传入异步报表 Modal 的常用 `reportLabelI18nKey`（值即 i18n key） */
export const dashboardAsyncReportLabelI18nKeys = {
    sorting: 'dashboard.sorting.title',
    quality: 'dashboard.quality.title',
    scale: 'dashboard.scale.title',
    lastMile: 'dashboard.lastmile.title',
    dspWeeklyRanking: 'dashboard.delivery.dspWeeklyRankingExportLabel',
    dspDeliveryCompletedSummary: 'wms.delivery.deliveryCompletedSummary.asyncExportReportLabel',
    dspDeliveryCompletedDetailExport: 'wms.delivery.deliveryCompletedSummary.asyncDetailExportReportLabel',
    wmsNoUpdate: 'wms.dashboard.noUpdate.asyncExportReportLabel',
    inhubSorting: 'wms.delivery.inhubDashboard.sorting.asyncExportReportLabel',
    inhubTransport: 'wms.delivery.inhubDashboard.transport.asyncExportReportLabel',
    qcPenaltyUpload: 'qualityControl.menu.penaltyUpload',
    undeliverableUploadDetail: 'qualityControl.undeliverableUpload.title',
    pricingFailureRevisionExport: 'settlement.revise.pricingFailureExport',
    preBillRevisionTaskDetailExport: 'settlement.revise.preBillRevisionPage.detailExportToDownloadCenter',
    pickupSiteDetail: 'dashboard.pickup.siteDetailExportLabel',
    pickupReservationDetail: 'dashboard.pickup.reservationDetailExportLabel',
    appealReviewExport: 'partnerControl.menu.appealReview',
} as const;

/** 与 {@link dashboardAsyncReportLabelI18nKeys} 中取值一致的报表名称 key，用于 `AsyncReportDownloadModal` 类型约束 */
export type DashboardAsyncReportLabelI18nKey =
    (typeof dashboardAsyncReportLabelI18nKeys)[keyof typeof dashboardAsyncReportLabelI18nKeys];
